import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { bookingsServices } from '@services';
import { showError } from '@utils';
import { QUERY_KEYS } from 'constants/queryKeys';

export const useB2BAllOrdersOperations = (enableFetch = true) => {
  const vehiclesResponse = useQuery(
    [QUERY_KEYS.GET_B2B_ALL_VEHICLES_KEY],
    () => bookingsServices.getWWWVehicles(),
    { enabled: enableFetch }
  );

  const vehicles = vehiclesResponse?.data?.data?.map((item) => ({
    value: item.id,
    text: `(${item.id}) ${item.title} - ${item.fee}€`,
  }));

  useEffect(() => {
    if (vehiclesResponse.isError) {
      showError(vehiclesResponse?.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehiclesResponse.isError]);

  return {
    isLoading: vehiclesResponse?.isLoading,
    vehicles,
  };
};
